import { render, staticRenderFns } from "./takvim.vue?vue&type=template&id=aa9ca624"
import script from "./takvim.vue?vue&type=script&lang=js"
export * from "./takvim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports